import React, { useEffect, useState } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiButton, EuiLoadingSpinner, EuiText, EuiSpacer } from '@elastic/eui';
import API from '../../api/axios/API';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { getLiveOrders } from '../../api/liveOrders/getLiveOrderNewAPI';
import { getLiveOrderDetailsAPI } from '../../api/liveOrders/getLiveOrderDetailsAPI';

export const AdlogsRiderTab = ({ service = 'adlogs', label = 'Adlogs', ...props }) => {
    const { order, onOrderStatusChange } = props;
    const [priceEstimate, setPriceEstimate] = useState({});
    const dispatch = useDispatch();
    const [adlogsError, setAdlogsError] = useState({});
    const [isLoadingEstimate, setIsLoadingEstimate] = useState(true);
    const [isAssigning, setIsAssigning] = useState(false);

    const serviceQuery = service && service !== 'adlogs' ? `&service=${service}` : '';

    const tdStyle = {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    };

    const adlogsCostEstimate = async () => {
        let adlogsResponse;
        setIsLoadingEstimate(true);
        try {
            adlogsResponse = await API.post(`/restaurants/:restaurantId/adlogs/get-order-estimation-time?order_id=${props.orderId}${serviceQuery}`);
        } catch (error) {
            console.log('error',error)
            adlogsResponse = error;
        }

        if (adlogsResponse.success) {
            setPriceEstimate(adlogsResponse);
        } else {
            if (
                adlogsResponse?.message === 'NO_FREE_RIDER_AVAILABLE_PLEASE_TRY_AGAIN_IN_SOME_TIME' ||
                adlogsResponse?.message?.includes('NO_FREE_RIDER_AVAILABLE_PLEASE_TRY_AGAIN_IN_SOME_TIME') ||
                adlogsResponse?.message?.includes('NO_FREE_RIDER_AVAILABLE')
            ) {
                setAdlogsError({
                    title: 'SURGE ALERT',
                    body: 'Due to excessive orders, there may be a delay in rider assignment and surge fees might be applicable.',
                });
            } else if (adlogsResponse?.message?.message) {
                alert(adlogsResponse?.message?.message);
            } else {
                setAdlogsError({});
                alert(adlogsResponse.message);
            }
        }
        setIsLoadingEstimate(false);
    };

    useEffect(() => {
        adlogsCostEstimate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const assignAdlogsRider = async () => {
        let adlogsResponse = '';
        setIsAssigning(true);
        try {
            adlogsResponse = await API.post(`/restaurants/:restaurantId/adlogs/assign-order?order_id=${props.orderId}${serviceQuery}`);
        } catch (error) {
            adlogsResponse = error;
        }

        if (adlogsResponse.success) {
            dispatch(getLiveOrders());
            dispatch(getLiveOrderDetailsAPI());
            props.setRiderModalOpen();
        } else {
            alert(adlogsResponse.message);
        }
        setIsAssigning(false);
    };
console.log('isLoadingEstimate',isLoadingEstimate)
    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                {isLoadingEstimate ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '90px' }}>
                        <EuiLoadingSpinner size="xl" />
                    </div>
                ) : (<>
                        {!isEmpty(priceEstimate) && priceEstimate.estimation &&
                            <>
                                {priceEstimate?.estimation?.service_available ? (
                                    <EuiFlexItem>
                                        <b>{label} Estimates</b>
                                        <table style={{ marginTop: '10px' }}>
                                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Pickup Estimation</td>
                                                <td style={tdStyle}>
                                                    {priceEstimate?.estimation?.to_pickup?.eta_min
                                                        ? `${priceEstimate.estimation.to_pickup.eta_min} Mins`
                                                        : ''}
                                                </td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Distance</td>
                                                <td style={tdStyle}>
                                                    {priceEstimate?.estimation?.distance
                                                        ? `${priceEstimate.estimation.distance} KM`
                                                        : ''}
                                                </td>
                                            </tr>

                                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Delivery Cost</td>

                                                <td style={tdStyle}>
                                                    {priceEstimate?.estimation?.estimated_price
                                                        ? `₹${parseFloat(
                                                            priceEstimate.estimation.estimated_price
                                                        ).toFixed(2)}`
                                                        : ''}
                                                </td>
                                            </tr>
                                        </table>
                                    </EuiFlexItem>
                                ) : (
                                    <EuiFlexItem>
                                        <b>{label} Estimates</b>
                                        <table style={{ marginTop: '10px' }}>
                                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Reason</td>
                                                <td style={tdStyle}>
                                                    {priceEstimate?.message || 'Service not available'}
                                                </td>
                                            </tr>
                                        </table>
                                    </EuiFlexItem>
                                )}
                            </>
                        }
                    </>)}
                {!isEmpty(adlogsError) ? (
                    <EuiFlexItem style={{ maxWidth: 320 }}>
                        <EuiSpacer size='s' />
                        <EuiText color='warning'>{adlogsError.title}</EuiText>
                        <EuiText style={{}} size='s' color='warning'>
                            {adlogsError.body}
                        </EuiText>
                    </EuiFlexItem>
                ) : null}
            </EuiFlexItem>
            <EuiFlexItem style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <EuiButton
                    disabled={!priceEstimate?.estimation?.service_available && isEmpty(adlogsError)}
                    fullWidth={true}
                    fill
                    onClick={assignAdlogsRider}
                    isLoading={isAssigning}
                >
                    Assign {label} Rider
                </EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};